import { BroadcastVideoInputDialog } from "./components/BroadcastVideoInputDialog/BroadcastVideoInputDialog";
import { useBroadcastVideoActions } from "./hooks/useBroadcastVideoActions";

interface IBroadcastVideoInputContainerProps {
  onClose: () => void;
}

const BroadcastVideoInputContainer = ({
  onClose,
}: IBroadcastVideoInputContainerProps) => {
  const { updateIsVideoControlsEnabled } = useBroadcastVideoActions();

  const handleIsVideoControlsEnabledChange = (isChecked: boolean) => {
    updateIsVideoControlsEnabled(isChecked);
  };

  return (
    <BroadcastVideoInputDialog
      handleIsVideoControlsEnabledChange={handleIsVideoControlsEnabledChange}
      onClose={onClose}
    />
  );
};

export default BroadcastVideoInputContainer;
